import type { Action } from './actions'

export type State = {
    available: Array<string>
}

const initialState: State = {
    available: []
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'FEATURES_RECEIVED':
            return {
                ...state,
                available: action.features
            }
        default:
            return state
    }
}
